import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { filter, map } from 'rxjs/operators';

import { DialogImageUploadComponent } from './dialog-image-upload/dialog-image-upload.component';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
})
export class UploadFileComponent {
  @Input() documentType: string;
  @Input() imageUrl: string;
  @Input() text: string;
  @Input() raised: boolean;
  @Input() color: string;
  @Output() imageChanged: EventEmitter<any> = new EventEmitter();

  constructor(private dialog: MatDialog) {}

  openDialog(imageUrl: string, documentType: string) {
    const config: any = {
      autoFocus: false,
      width: '500px',
      data: {
        imageUrl,
        documentType,
      },
    };
    this.dialog
      .open(DialogImageUploadComponent, config)
      .afterClosed()
      .pipe(
        filter((data: any) => data),
        map((data: any) => this._onImageChange(data.imageUrl)),
      )
      .subscribe();
  }

  _onImageChange(imageUrl: string): void {
    this.imageChanged.emit(imageUrl);
  }
}
